import * as React from 'react';

interface DisclaimerHeightState {
    disclaimerHeights: number[];
}
interface DisclaimerHeightContextType extends DisclaimerHeightState {
    dispatch: React.Dispatch<DispatchActions>;
}

const ADD_HEIGHT = 'ADD_HEIGHT';
const RESET_STATE = 'RESET_STATE';

type AddHeightType = typeof ADD_HEIGHT;
type ResetStateType = typeof RESET_STATE;
interface DisclaimerActions {
    addHeight: AddHeightType;
    resetState: ResetStateType;
}

export const disclaimerActions: DisclaimerActions = {
    addHeight: ADD_HEIGHT,
    resetState: RESET_STATE
};
const DisclaimerHeightContext = React.createContext<
    DisclaimerHeightContextType | undefined
>(undefined);

type DispatchActions = {type: AddHeightType | ResetStateType; payload?: number};

interface HeightProviderProps {
    children: React.ReactNode;
}

const initialState: DisclaimerHeightState = {
    disclaimerHeights: []
};

export const DisclaimerHeightProvider: React.FC<HeightProviderProps> = ({
    children
}) => {
    const [state, dispatch] = React.useReducer(
        disclaimerHeightsReducer,
        initialState
    );

    return (
        <DisclaimerHeightContext.Provider
            value={{disclaimerHeights: state.disclaimerHeights, dispatch}}
        >
            {children}
        </DisclaimerHeightContext.Provider>
    );
};

export const useDisclaimerHeights = () => {
    const context = React.useContext(DisclaimerHeightContext);

    if (!context) {
        throw new Error(
            'useDisclaimerHeight must be used within a DisclaimerHeightProvider'
        );
    }

    return context;
};

export const disclaimerHeightsReducer = (
    {disclaimerHeights}: DisclaimerHeightState,
    {payload, type}: DispatchActions
): DisclaimerHeightState => {
    switch (type) {
        case disclaimerActions.addHeight:
            if (payload) {
                return {
                    disclaimerHeights: [...disclaimerHeights, payload]
                };
            }

            return {disclaimerHeights};
        case disclaimerActions.resetState:
            return initialState;
        default:
            console.warn('Disclaimer Dispatch Action not recognized.');
            return {disclaimerHeights};
    }
};
